var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_COMPANIES = 'api/company';
export const updateCompanyById = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_COMPANIES}/${companyId}`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching updateCompanyById:', error);
            throw error;
        }
    });
};
export const updateCompanyLogoById = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            //TODO: company logo requires to have content-type false?
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}`, 'Content-Type': false }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_COMPANIES}/${companyId}`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching updateCompanyLogoById:', error);
            throw error;
        }
    });
};
export const updateCompanyTaxInfoById = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_COMPANIES}/${companyId}/taxInfo`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching updateCompanyTaxInfoById:', error);
            throw error;
        }
    });
};
export const updateCompanySubscriptionBillingInfoById = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_COMPANIES}/${companyId}/subscriptionBillingInfo`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching updateCompanySubscriptionBillingInfoById:', error);
            throw error;
        }
    });
};
export const updateGarmentAttributeCatalogsById = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.patch(`${GET_SET_COMPANIES}/${companyId}/garment-attribute-catalogs`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching updateGarmentAttributeCatalogsById:', error);
            throw error;
        }
    });
};
